export const constants = {
  SUCCESS_STATUS: "success",
  ERROR_STATUS: "error",
  FAIL_STATUS: "fail",
  MAX_RESULTS: 100,
  COLOR_PRIMARY: "#007bff",
  COLOR_SECONDARY: "#6c757d",
  COLOR_SUCCESS: "#28a745",
  COLOR_DANGER: "#dc3545",
  DEFAULT_TIMEZONE: "America/Denver",
};

export const phoneRegex = /^(\(\d{3}\)|\d{3})[-\s]?\d{3}[-\s]?\d{4}$/;

export const THEME_STORAGE_KEY = "siteThemeMode";
export const THEME_ATTRIBUTE = "data-bs-theme";

export const colors = {
  red: "#FF0000",
  redLight: "#FA7F7F",
  pink: "#ff8fec",
  green: "#00ff7f",
  green2: "#00CC66",
  blue: "#2274A5",
  orange: "#F75C03",
  gray: "#A7A9AC",
  black: "#000000",
  powderBlue: "#93BEDF",
  iceBlue: "#8EF9F3",
  purple: "#6A0572",
  magenta: "#922D50",
  yellow: "#ffae00",
};

const spreadsheetBaseTheme = {
  config: {
    useSystemColorMode: false,
  },
  styles: {
    global: {
      "html, body": {
        background: "transparent !important",
      },
      body: {
        color: "inherit !important",
      },
    },
  },
};

export const spreadsheetLightTheme = {
  ...spreadsheetBaseTheme,
  config: {
    ...spreadsheetBaseTheme.config,
    initialColorMode: "light",
  },
  colors: {
    textColor: "#1f2937",
    subtitleColor: "#6b7280",
    inactiveColor: "#9ca3af",
    border: "#e5e7eb",
    background: "#ffffff",
    backgroundAlpha: "rgba(255,255,255,0)",
    secondaryBackground: "#f3f4f6",
    highlight: "#e5e7eb",
  },
};

export const spreadsheetDarkTheme = {
  ...spreadsheetBaseTheme,
  config: {
    ...spreadsheetBaseTheme.config,
    initialColorMode: "dark",
  },
  colors: {
    textColor: "#e5e7eb",
    subtitleColor: "#9ca3af",
    inactiveColor: "#6b7280",
    border: "#374151",
    background: "#111827",
    backgroundAlpha: "rgba(17,24,39,0)",
    secondaryBackground: "#1f2937",
    highlight: "#374151",
  },
};
